import { QueryClient } from 'react-query';
import { reactQueryDefaultOptions } from '@ace/react-utilities';

export default function createQueryClient() {
    const queryClient = new QueryClient({
        defaultOptions: {
          queries: {...reactQueryDefaultOptions}
        }
    });

    return queryClient;
}